import type { AxiosInstance } from 'axios';

export default class ApiBase {
	client: AxiosInstance;

	constructor(client: AxiosInstance) {
		this.client = client;
	}
}
